import createIntlWithLocale from '../../internal/createIntlWithLocale';
function getYear(date, locale, timeZone, config, reports, analytics) {
    const intl = createIntlWithLocale(locale, config, reports, analytics);
    return intl.formatDate(date, {
        timeZone,
        year: 'numeric'
    });
}
const regexYear = /(-year)\?/;
export default function resolveStyle(date, options, config, reports, analytics) {
    const { style } = options;
    let resultingStyle = style;
    if (regexYear.test(style)) {
        const givenDateYear = getYear(date, options.locale, options.timeZone, config, reports, analytics);
        const currentYear = getYear(Date.now(), options.locale, options.timeZone, config, reports, analytics);
        if (givenDateYear && currentYear && givenDateYear === currentYear) {
            resultingStyle = resultingStyle.replace(regexYear, '');
        } else {
            resultingStyle = resultingStyle.replace(regexYear, '$1');
        }
    }
    return resultingStyle;
}

//# sourceMappingURL=resolveStyle.js.map